/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DashboardAliases {
  AVATAR = 'avatar',
  AVATAR_0 = 'avatar-0',
  BUTTOMS = 'buttoms',
  BUTTON_SEE_MORE = 'button-see-more',
  CARD_DASHBOARD = 'card-dashboard',
  CARD_TASK = 'card-task',
  DECK_APPOINTMENTS = 'deck-appointments',
  DECK_TASKS = 'deck-tasks',
  FETCH_APPOINTMENTS = 'fetch-appointments',
  FETCH_DASHBOARD = 'fetch-dashboard',
  FETCH_TASKS = 'fetch-tasks',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_ADDRESS = 'field-address',
  FIELD_ALERT = 'field-alert',
  FIELD_BOND_TYPE = 'field-bond-type',
  FIELD_COMMERCIAL_NAME = 'field-commercial-name',
  FIELD_PLACE_SERVICE = 'field-place-service',
  FIELD_PROVIDER = 'field-provider',
  FIELD_PROVIDER_TYPE = 'field-provider-type',
  FIELD_TELEPHONE = 'field-telephone',
  FORM_MESSAGE = 'form-message',
  HPMS_CUSTOM_CARD_APPOINTMENTS = 'hpms-custom-card-appointments',
  LAYOUT_DASHBOARD = 'layout-dashboard',
  LAYOUT_INTERIOR = 'layout-interior',
  LAYOUT_TASKS = 'layout-tasks',
  MAPPER_0 = 'mapper-0',
  MAPPER_2 = 'mapper-2',
  MODAL_REFUSE = 'modal-refuse',
  PANEL_ACTION = 'panel-action',
  PANEL_APPOINTMENTS = 'panel-appointments',
  PANEL_CONTENT = 'panel-content',
  PANEL_DASHBOARD = 'panel-dashboard',
  PANEL_LIST = 'panel-list',
  PANEL_MODAL = 'panel-modal',
  PANEL_TASKS = 'panel-tasks',
  PANEL_TITLE = 'panel-title',
  PANEL_TITLE_APPOINTMENTS = 'panel-title-appointments',
  PROGRESS_BAR_0 = 'progress-bar-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_AREA_0 = 'text-area-0',
  TEXT_TITLE_APPOINTMENTS = 'text-title-appointments',
  TEXT_TITLE_TASKS = 'text-title-tasks',
}
export { DashboardAliases };
